import { useTranslation } from 'react-i18next';
import React, { useEffect, useMemo } from 'react';
import { FieldValues, Control, useWatch, UseFormSetValue } from 'react-hook-form';
import dayjs from 'dayjs';

import { EligibilitiesFields, CheckableFields } from '@/components';
import { Participation } from './fields';

import style from './index.module.scss';

export const CommonFields = ({
  control,
  disabled,
  setValue,
  hiddenEligibilityFields,
}: {
  control: Control<FieldValues, object>;
  disabled?: boolean;
  setValue: UseFormSetValue<any>;
  hiddenEligibilityFields?: string[];
}) => {
  const { t } = useTranslation();

  const endsTime = useMemo(() => dayjs().add(24, 'h').format('MM/DD HH:mm'), []);

  const followerUserPermission = useWatch({ control, name: 'permissions.has_followed_user' });

  const participation = useMemo(
    () =>
      Participation.map(field => {
        if (field.name === 'operations.follow_creator') {
          return { ...field, disabled: !!followerUserPermission };
        }
        return field;
      }),
    [followerUserPermission],
  );

  useEffect(() => {
    if (followerUserPermission) {
      setValue('operations.follow_creator', false);
    }
  }, [followerUserPermission, setValue]);

  return (
    <>
      <EligibilitiesFields
        control={control}
        disabled={disabled}
        hiddenEligibilityFields={hiddenEligibilityFields}
      />
      {/* <div className={style.formTitle}>{t('LuckyDraw_CommonFields.1u688ka')}</div>
      <CheckableFields control={control} fields={participation} disabled={disabled} /> */}
      <div className={style.drawEnds}>
        {t('LuckyDraw_CommonFields.b2fllu')}
        <span className={style.drawEndLength}>24h</span>
        {t('LuckyDraw_CommonFields.endsAt', { time: endsTime })}
      </div>
    </>
  );
};
